import React, { useEffect, useState, createElement, Component } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2, AlertTriangle } from 'lucide-react';
import { signupFormsApi, formConfigsApi, emailTemplatesApi, newslettersApi, extractLookupId, SignupFormRecord } from '../services/creatorApi';
// Duplicate of the logic in EmbedCodes.tsx/SignupFormEditor.tsx
// Ideally this would be shared, but keeping it self-contained for now to avoid refactoring risk
interface EnrichmentData {
  emailHtml: string;
  emailSubject: string;
  newsletterId: string;
  region: string;
  redirectUrl: string;
  appOrigin: string;
}
function escapeForJSString(str: string): string {
  return str.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/<\/script>/gi, '<\\/script>');
}
function generateSubmissionScript(team: string, slug: string, enrichment?: EnrichmentData | null, successMessage?: string, submittingText?: string, errorMessage?: string, validationErrorMessage?: string): string {
  var safeTeam = team.replace(/'/g, "\\'").replace(/\\/g, '\\\\');
  var safeSuccessMsg = escapeForJSString(successMessage || 'Successfully submitted! Please check your email to confirm.');
  var safeSubmittingText = escapeForJSString(submittingText || 'Enviando…');
  var safeErrorMsg = escapeForJSString(errorMessage || 'Error al enviar. Inténtalo de nuevo.');
  var safeValidationMsg = escapeForJSString(validationErrorMessage || 'Por favor, complete todos los campos obligatorios.');
  var safeEmailHtml = enrichment ? escapeForJSString(enrichment.emailHtml) : '';
  var safeEmailSubject = enrichment ? escapeForJSString(enrichment.emailSubject) : '';
  var safeNewsletterId = enrichment ? escapeForJSString(enrichment.newsletterId) : '';
  var safeRegion = enrichment ? escapeForJSString(enrichment.region) : '';
  var safeRedirectUrl = enrichment ? escapeForJSString(enrichment.redirectUrl) : '';
  var safeAppOrigin = enrichment ? escapeForJSString(enrichment.appOrigin) : '';
  var lines: string[] = [];
  lines.push('(function(){');
  lines.push("  var form=document.querySelector('form');");
  lines.push('  if(!form)return;');
  // Toast notification function — top center
  lines.push('  function showToast(msg,isErr){');
  lines.push("    var t=document.getElementById('_ft52');if(t)t.remove();");
  lines.push("    var s=document.createElement('style');");
  lines.push("    s.textContent='@keyframes _fti{from{transform:translate(-50%,-16px);opacity:0}to{transform:translate(-50%,0);opacity:1}}@keyframes _fto{from{opacity:1}to{opacity:0;transform:translate(-50%,-16px)}}';");
  lines.push('    document.head.appendChild(s);');
  lines.push("    t=document.createElement('div');t.id='_ft52';");
  lines.push("    t.style.cssText='position:fixed;top:24px;left:50%;transform:translateX(-50%);z-index:2147483647;background:'+(isErr?'#dc2626':'#16a34a')+';color:#fff;padding:14px 18px;border-radius:10px;font-size:14px;font-weight:500;box-shadow:0 8px 24px rgba(0,0,0,0.18);max-width:380px;display:flex;align-items:center;gap:12px;font-family:-apple-system,BlinkMacSystemFont,sans-serif;animation:_fti 0.3s ease';");
  lines.push("    var sp=document.createElement('span');sp.textContent=msg;");
  lines.push("    var cl=document.createElement('button');cl.innerHTML='&times;';");
  lines.push("    cl.style.cssText='background:none;border:none;color:rgba(255,255,255,0.8);font-size:20px;cursor:pointer;padding:0;line-height:1;margin-left:4px;flex-shrink:0';");
  lines.push("    function dismiss(){t.style.animation='_fto 0.3s ease forwards';setTimeout(function(){if(t&&t.parentNode)t.remove()},300)}");
  lines.push('    cl.onclick=dismiss;t.appendChild(sp);t.appendChild(cl);document.body.appendChild(t);');
  lines.push('    setTimeout(dismiss,5000);');
  lines.push('  }');
  // Validation helper
  lines.push('  function validateForm(){');
  lines.push("    var rq=form.querySelectorAll('[required]');");
  lines.push('    for(var i=0;i<rq.length;i++){');
  lines.push('      var el=rq[i];');
  lines.push("      if(el.type==='checkbox'){if(!el.checked)return false;}");
  lines.push("      else if(el.type==='radio'){");
  lines.push("        var g=form.querySelectorAll('input[name=\"'+el.name+'\"]');");
  lines.push('        var ok=false;for(var j=0;j<g.length;j++){if(g[j].checked){ok=true;break;}}');
  lines.push('        if(!ok)return false;');
  lines.push('      }');
  lines.push('      else{if(!el.value||!String(el.value).trim())return false;}');
  lines.push('    }');
  lines.push('    return true;');
  lines.push('  }');
  lines.push('  function genToken(){');
  lines.push('    var ts=Date.now().toString(36);');
  lines.push("    var r='';for(var i=0;i<16;i++)r+=Math.floor(Math.random()*36).toString(36);");
  lines.push("    return ts+'_'+r;");
  lines.push('  }');
  lines.push('  function renderTpl(tpl,vars){');
  lines.push('    var result=tpl;');
  lines.push('    for(var k in vars){');
  lines.push('      if(!vars.hasOwnProperty(k))continue;');
  lines.push("      var re=new RegExp('\\\\{\\\\{\\\\s*'+k.replace(/[.*+?^${}()|[\\]\\\\]/g,'\\\\$&')+'\\\\s*\\\\}\\\\}','gi');");
  lines.push("      result=result.replace(re,vars[k]||'');");
  lines.push('    }');
  lines.push('    return result;');
  lines.push('  }');
  lines.push("  form.addEventListener('submit',function(e){");
  lines.push('    e.preventDefault();');
  lines.push('    e.stopImmediatePropagation();');
  // Validate required fields
  lines.push("    if(!validateForm()){showToast('" + safeValidationMsg + "',true);return;}");
  lines.push('    var fd=new FormData(form);');
  lines.push('    var fields={};');
  lines.push('    fd.forEach(function(v,k){fields[k]=v;});');
  lines.push('    if(Object.keys(fields).length===0){');
  lines.push("      var inputs=form.querySelectorAll('input,select,textarea');");
  lines.push('      for(var i=0;i<inputs.length;i++){');
  lines.push('        var el=inputs[i];');
  lines.push("        var n=el.getAttribute('name')||el.getAttribute('id')||'';");
  lines.push("        if(n&&el.type!=='submit'&&el.type!=='button'){");
  lines.push("          if(el.type==='checkbox')fields[n]=el.checked?'yes':'no';");
  lines.push("          else if(el.type==='radio'){if(el.checked)fields[n]=el.value;}");
  lines.push("          else fields[n]=el.value||el.textContent||'';");
  lines.push('        }');
  lines.push('      }');
  lines.push('    }');
  lines.push('    var btn=form.querySelector(\'[type="submit"],button:not([type])\');');
  lines.push('    var origText="";');
  lines.push('    if(btn){origText=btn.textContent;btn.disabled=true;btn.textContent="' + safeSubmittingText + '";}');
  lines.push("    var email=fields.email||fields.Email||fields.email_address||fields.EMAIL||fields.emailAddress||fields.e_mail||'';");
  lines.push('    var token=genToken();');
  if (enrichment && enrichment.appOrigin) {
    lines.push("    var confirmUrl='" + safeAppOrigin + "/confirm?token='+encodeURIComponent(token);");
  } else {
    lines.push("    var confirmUrl=window.location.origin+'/confirm?token='+encodeURIComponent(token);");
  }
  if (enrichment && enrichment.emailHtml) {
    lines.push("    var tplHtml='" + safeEmailHtml + "';");
    lines.push("    var tplSubject='" + safeEmailSubject + "';");
    lines.push('    var tplVars={};');
    lines.push('    for(var fk in fields){if(fields.hasOwnProperty(fk))tplVars[fk]=fields[fk];}');
    lines.push('    tplVars.confirmation_link=confirmUrl;');
    lines.push("    tplVars.team_name='" + safeTeam + "';");
    lines.push('    var renderedHtml=renderTpl(tplHtml,tplVars);');
    lines.push('    var renderedSubject=renderTpl(tplSubject,tplVars);');
  } else {
    lines.push("    var renderedHtml='';");
    lines.push("    var renderedSubject='';");
  }
  lines.push('    var payload={');
  lines.push('      Form_Payload:JSON.stringify(fields),');
  lines.push("      Status:'Not Subscribed',");
  lines.push("      Team:'" + safeTeam + "',");
  lines.push('      Subscriber_Email:email,');
  lines.push('      Confirmation_Token:token,');
  if (enrichment && enrichment.newsletterId) lines.push("      Newsletter_ID:'" + safeNewsletterId + "',");
  if (enrichment && enrichment.region) lines.push("      Region:'" + safeRegion + "',");
  if (enrichment && enrichment.redirectUrl) lines.push("      Redirect_URL:'" + safeRedirectUrl + "',");
  lines.push('      Rendered_Email_HTML:renderedHtml,');
  lines.push('      Rendered_Email_Subject:renderedSubject');
  lines.push('    };');
  lines.push("    fetch('https://www.websiteforge.com/custom/chosen_zoho_api.php',{");
  lines.push("      method:'POST',");
  lines.push("      headers:{'Content-Type':'application/json','API-KEY':'ud7^3jf(80'},");
  lines.push('      body:JSON.stringify({');
  lines.push("        url:'https://www.zohoapis.com/creator/v2.1/data/52studios/campaigns/form/Submissions',");
  lines.push("        method:'POST',");
  lines.push('        data:{data:payload}');
  lines.push('      })');
  lines.push('    })');
  lines.push('    .then(function(r){return r.json();})');
  lines.push('    .then(function(data){');
  lines.push("      showToast('" + safeSuccessMsg + "',false);");
  lines.push('      if(btn){btn.disabled=false;btn.textContent=origText;}');
  lines.push('      form.reset();');
  lines.push('    })');
  lines.push('    .catch(function(err){');
  lines.push("      showToast('" + safeErrorMsg + "',true);");
  lines.push('      if(btn){btn.disabled=false;btn.textContent=origText;}');
  lines.push("      console.error('Form submission error:',err);");
  lines.push('    });');
  lines.push('  },true);');
  lines.push('})();');
  return lines.join('\n');
}
export function PublicFormEmbed() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [record, setRecord] = useState<SignupFormRecord | null>(null);
  const [scriptContent, setScriptContent] = useState('');
  useEffect(() => {
    if (!slug) return;
    const loadForm = async () => {
      try {
        setLoading(true);
        const form = await signupFormsApi.findBySlug(slug);
        if (!form) {
          setError('Form not found');
          return;
        }
        if (form.Status === 'archived' || form.Status === 'draft') {
          setError('This form is not active');
          return;
        }
        setRecord(form);
        // Load enrichment data
        let enrichment: EnrichmentData | null = null;
        let successMessage = 'Successfully submitted! Please check your email to confirm.';
        let submittingText = 'Enviando…';
        let errorMessage = 'Error al enviar. Inténtalo de nuevo.';
        let validationErrorMessage = 'Por favor, complete todos los campos obligatorios.';
        // Extract settings from Builder_Schema
        if (form.Builder_Schema) {
          try {
            const schema = JSON.parse(form.Builder_Schema);
            if (schema.successMessage) successMessage = schema.successMessage;
            if (schema.submittingText) submittingText = schema.submittingText;
            if (schema.errorMessage) errorMessage = schema.errorMessage;
            if (schema.validationErrorMessage) validationErrorMessage = schema.validationErrorMessage;
          } catch {}
        }
        // Extract success message from Builder_Schema
        if (form.Builder_Schema) {
          try {
            const schema = JSON.parse(form.Builder_Schema);
            if (schema.successMessage) successMessage = schema.successMessage;
          } catch {}
        }
        try {
          // 1. Find Form Configuration
          const configs = await formConfigsApi.findByFormId(form.ID);
          if (configs.length > 0) {
            const config = configs[0];
            const templateId = extractLookupId(config.Email_Template);
            if (templateId) {
              // 2. Fetch Email Template
              const template = await emailTemplatesApi.get(templateId);
              if (template) {
                // 3. Find Newsletter
                let newsletterId = '';
                try {
                  const allNewsletters = await newslettersApi.list();
                  const newsletter = allNewsletters.find(nl => {
                    const nlFormId = extractLookupId(nl.Sign_Up_Form);
                    return nlFormId === form.ID;
                  });
                  if (newsletter) newsletterId = newsletter.Newsletter_ID || '';
                } catch {}
                // 4. Extract redirect URL
                let redirectUrl = '';
                const rawLink = (template as any).Confirmation_Link;
                if (rawLink) {
                  redirectUrl = typeof rawLink === 'string' ? rawLink : rawLink?.url || '';
                }
                enrichment = {
                  emailHtml: template.Email_HTML_Body || '',
                  emailSubject: template.Email_Subject || '',
                  newsletterId,
                  region: config.Region || template.Region || '',
                  redirectUrl,
                  appOrigin: window.location.origin
                };
              }
            }
          }
        } catch (err) {
          console.warn('Failed to load enrichment data:', err);
        }
        // Generate the submission script
        const script = generateSubmissionScript(form.Team || '', slug, enrichment, successMessage, submittingText, errorMessage, validationErrorMessage);
        setScriptContent(script);
      } catch (err) {
        console.error('Error loading form:', err);
        setError('Failed to load form');
      } finally {
        setLoading(false);
      }
    };
    loadForm();
  }, [slug]);
  // Inject script after render
  useEffect(() => {
    if (!loading && !error && record && scriptContent) {
      // Clean up previous scripts if any
      const existingScript = document.getElementById('form-submission-script');
      if (existingScript) existingScript.remove();
      const script = document.createElement('script');
      script.id = 'form-submission-script';
      script.textContent = scriptContent;
      document.body.appendChild(script);
      // Also inject user's custom JS if present
      if (record.JavaScript1) {
        const userScript = document.createElement('script');
        userScript.id = 'form-user-script';
        userScript.textContent = record.JavaScript1;
        document.body.appendChild(userScript);
      }
      return () => {
        const s1 = document.getElementById('form-submission-script');
        if (s1) s1.remove();
        const s2 = document.getElementById('form-user-script');
        if (s2) s2.remove();
      };
    }
  }, [loading, error, record, scriptContent]);
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-transparent" data-id="element-3794">
        <Loader2 className="h-8 w-8 text-blue-500 animate-spin" data-id="element-3795" />
      </div>;
  }
  if (error || !record) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4" data-id="element-3796">
        <div className="text-center max-w-md" data-id="element-3797">
          <div className="mx-auto w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-3798">
            <AlertTriangle className="h-6 w-6 text-red-600" data-id="element-3799" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-3800">
            Unavailable
          </h3>
          <p className="text-gray-500" data-id="element-3801">{error || 'Form not found'}</p>
        </div>
      </div>;
  }
  return <>
      <style data-id="element-3802">{`
        body { margin: 0; padding: 0; background: transparent; }
        /* Reset basic styles for embed consistency */
        * { box-sizing: border-box; }
        ${record.CSS || ''}
      `}</style>
      <div id={`form-52s-${slug}`} dangerouslySetInnerHTML={{
      __html: record.HTML || ''
    }} data-id="element-3803" />
    </>;
}